import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchBrickWorkingReportType } from "../../../domain/models/brick-working-report/fetch-brick-working-report";
import { FetchBrickWorkingReports } from "../../../domain/useages/brick-working-reports/fetch-brick-working-reports";
import { RemoteFetchBrickWorkingReport } from "../../../data/usecases/brick-working-reports/remote-fetch-brick-working-report";

export interface FetchBrickWorkingReportInterface {
  FetchBrickWorkingReport: FetchBrickWorkingReportType;
  FetchBrickWorkingReportState: FetchState;
  fetchBrickWorkingReportResponse: Function;
}

const initialStates = {
  FetchBrickWorkingReport: {} as FetchBrickWorkingReportType,
  FetchBrickWorkingReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchBrickWorkingReportSlice: StateCreator<
  FetchBrickWorkingReportInterface
> = (set) => ({
  ...initialStates,
  fetchBrickWorkingReportResponse: async (
    params: FetchBrickWorkingReports.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchBrickWorkingReport = new RemoteFetchBrickWorkingReport(
      `${BASE_URL}${Endpoints.FETCH_BRICK_WORKING_REPORT}`,
      axiosHttpClient
    );

    set(() => ({ FetchBrickWorkingReportState: FetchState.LOADING }));
    let result = await remoteFetchBrickWorkingReport.fetch(params);
    return result;
},
});
